import React from 'react';
import { Spinner } from 'reactstrap';

const Loader2 = (props) => {
    return (
        <React.Fragment>
            <div className="d-flex justify-content-center mx-2 mt-5">
                <Spinner color="primary"> Loading... </Spinner>
            </div>
        </React.Fragment>
    );
};

export default Loader2;
